import { Button } from "@/components/ui/button";
import type { CustomerDuplicate, DuplicateCandidate } from "@/lib/customer-duplicate";

interface DuplicateCustomerNoticeProps {
  duplicate: CustomerDuplicate<DuplicateCandidate & { poweroffice_customer_id?: number | null }>;
  actionLabel: string;
  onAction: () => void;
}

/**
 * Varsel i «Ny kunde» når kunden finnes fra før. Samme org.nr blokkerer
 * opprettelsen (se `findDuplicateCustomer`); samme navn er bare et hint.
 */
export function DuplicateCustomerNotice({ duplicate, actionLabel, onAction }: DuplicateCustomerNoticeProps) {
  const { customer, kind } = duplicate;
  const org = customer.organization_number ? `org.nr ${customer.organization_number}` : "uten org.nr";
  const po = customer.poweroffice_customer_id ? "Koblet til PowerOffice." : "Ikke koblet til PowerOffice.";
  return (
    <div role="alert" className="space-y-2 rounded-md border border-border bg-muted/40 p-3 text-sm">
      <p className="font-medium">
        {kind === "org"
          ? `${customer.name} finnes allerede som kunde`
          : `Det finnes en kunde med samme navn: ${customer.name}`}
      </p>
      <p className="text-muted-foreground">
        {kind === "org" ? `Samme org.nr. ${po}` : `${org}. Sjekk at det ikke er samme kunde før du oppretter en ny.`}
      </p>
      <Button type="button" size="sm" variant={kind === "org" ? "default" : "outline"} onClick={onAction}>
        {actionLabel}
      </Button>
    </div>
  );
}
